const minimumLength: { [key: string]: number } = {
  day: 1,
  month: 1,
  year: 4,
};

//  Avoid unnecessary API calls if child info is not correct.
export const isChildInfoCorrect = (childInfo: {
  [key: string]: string;
}): boolean => {
  for (const key in minimumLength) {
    const value = childInfo[key];

    // Ensure the value exists and its length meets the minimum requirement.
    if (!value || value.length < minimumLength[key]) {
      return false;
    }
  }

  return true;
};
